import { Fragment, type ReactNode } from 'react'
import { useEvaluatorPack } from '../addons'

/**
 * How the interface names the add-on pack — IMPLEMENTATION.md decision 30.
 *
 * Where the pack is not licensed, every mention of the Snapshot Evaluator carries a
 * star, and the passage it sits in carries the star's terms: an optional pack,
 * licensed separately. Where it is licensed there is nothing optional left to say,
 * so the star and the terms are not drawn at all. One component, so a new mention
 * cannot get either case wrong.
 */
export const EVALUATOR = 'Snapshot Evaluator'
export const ADD_ON_TERMS = 'Optional add-on pack, licensed separately.'

export function AddOnStar() {
  if (useEvaluatorPack()) return null
  return (
    <sup className="addon-star" title={ADD_ON_TERMS}>
      *
    </sup>
  )
}

/** The pack's name, starred. */
export function EvaluatorName({ strong = true }: { strong?: boolean }) {
  return (
    <>
      {strong ? <strong>{EVALUATOR}</strong> : EVALUATOR}
      <AddOnStar />
    </>
  )
}

/** The star's terms. A span shown as a block, so it can close a paragraph. */
export function AddOnFootnote() {
  if (useEvaluatorPack()) return null
  return <span className="addon-footnote">* {ADD_ON_TERMS}</span>
}

export function mentionsEvaluator(text: string): boolean {
  return text.includes(EVALUATOR)
}

/**
 * Plain text — the manual's, which is written once in `help.ts` — with the pack's
 * name starred wherever it appears. `render` draws the text between mentions.
 */
export function withStars(text: string, render: (piece: string) => ReactNode = (piece) => piece) {
  const pieces = text.split(EVALUATOR)
  if (pieces.length === 1) return render(text)
  return pieces.map((piece, i) => (
    <Fragment key={i}>
      {render(piece)}
      {i < pieces.length - 1 && <EvaluatorName strong={false} />}
    </Fragment>
  ))
}
